angular.module('KhBase').factory("GenusFactory", function ($resource) {
    return $resource('/api/genus/:id', {id: '@id'});
});
